import { useEffect, useState } from 'react'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import { CC_PRODUCT_ID, TOKEN_2 } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import { getTranslated, getHTMLObject } from "../../utils/CommonUtils"
import { sendGTMEvent } from '../../utils/GTMUtils'
import { useSelector } from "react-redux"
import { Button } from 'antd'
import UMCButton from '../common/UMCButton'
import UMCTable from "../common/UMCTable"
import TabExtraContent from '../common/TabExtraContent'
import getData from './GetData'
import CustomDialog from './CustomDialog'
import parse from 'html-react-parser'

////////////////////////////////////////////////
// Page to display present trunks in the system
////////////////////////////////////////////////
const TrunkList = ({ onAddSIPProfile, onSetPrerequisites }) => {

    const [trunkList, setTrunkList] = useState([]);
    const [items, setItems] = useState([]);
    const [updated, setUpdated] = useState(false);  // Add channels number parenthesis

    //    const [prerequisites, setPrerequisites] = useState([]);
    var prerequisites;
    const [message, setMessage] = useState([]);
    const [title, setTitle] = useState();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState();
    // Dialog footer button definition
    const [footer, setFooter] = useState([]);

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);

    var ccproductid = getSessionItem(CC_PRODUCT_ID);
    var nodeNumber = oxeAndClientInfo?.nodeNumber || "";

    // Adjust the trunk list to be conform with the JSON expected from the table
    function conformObj(obj) {
        var accesses;

        obj['key'] = obj['id'];
        if (updated === false) {
            if (obj['channelNb']) {
                switch (obj['t2Specificity']) {
                    case "SIP":
                        accesses = obj['channelNb'] / 2;
                        break;
                    case "IP_PRIVATE":
                        accesses = obj['channelNb'];
                        break;
                    default:
                        accesses = obj['channelNb'] / 2;
                        break;
                }
                obj['channelNb'] = accesses + " * 62 = " + accesses * 62;
            }
            setUpdated(true);
        }
        delete obj['prefix'];

        return obj;
    }

    // Handler for trunk list
    const trunkListHandler = (data) => {
        setTrunkList(data);
    }

    // Handler for prerequisites
    const prerequisitesHandler = (data) => {
        onSetPrerequisites(data);
        prerequisites = data;
    }

    // Function to manage async function to retrieve data
    const fetchData = async (url, headerSection, dataHandler) => {
        var response;

        dispatch(setContentLoading(true));
        response = await getData(url, headerSection, dataHandler);
        dispatch(setContentLoading(false));

        return response;
    };

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "LABEL_TRUNKLIST_PAGE")))
    }, [dict]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
        var url, headerSection, response;

        if (trunkList.length === 0) {
            url = SIP_URL + "/siptrunks/" + nodeNumber + "/" + ccproductid;
            headerSection = { headers: { "Authorization": `Bearer ${getSessionItem(TOKEN_2)}` } };
            response = fetchData(url, headerSection, trunkListHandler);

            setUpdated(false);
        }
    }, []);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    useEffect(() => {
        if (trunkList !== null)
            setItems(trunkList.map(obj => conformObj(obj)));
    }, [trunkList]);

    // Columns definition
    const columns = [
        {
            title: getTranslated(dict, "LABEL_ID_HDR"),
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: getTranslated(dict, "LABEL_NBCH_HDR"),
            dataIndex: 'channelNb',
            key: 'channelNb',
        },
        {
            title: getTranslated(dict, "LABEL_SIPPRVDR_HDR"),
            dataIndex: 'sipProvider',
            key: 'sipProvider',
        },
    ];

    // Additional header buttons
    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={["refresh", "help"]}
            handleRefresh={() => {
                // code to handle refresh action
                var url, headerSection, response;

                url = SIP_URL + "/siptrunks/" + nodeNumber + "/" + ccproductid;
                headerSection = { headers: { "Authorization": `Bearer ${getSessionItem(TOKEN_2)}` } };
                response = fetchData(url, headerSection, trunkListHandler);

                setUpdated(false);
            }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-trunk`, "_blank")
            }}
        />
    }

    // Modal message handlers
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
        onAddSIPProfile();
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // Dialog button definition
    const cancel =
        <Button key="cancel" type="primary" onClick={handleCancel} className="sip-modal-btn sip-navigation-back">
            {getTranslated(dict, "LABEL_CANCEL")}
        </Button>;
    const ok =
        <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
            {getTranslated(dict, "LABEL_NEXT")}
        </Button>;
    const close =
        <Button key="cancel" type="primary" onClick={handleCancel} className="sip-modal-btn" >
            {getTranslated(dict, "LABEL_CLOSE")}
        </Button>;

    // Before allowing to continue, verification if the prerequisites are present. If yes, display the backup dialog, else display error dialog.
    const createNewSIPTrunk = async () => {
        // Send GTM event for SIP trunk creation started
        sendGTMEvent({
            event: "umc_SIP_trunk_creation_started"
        })

        var url, headerSection, response, errmsg, msg, prereq_error = false;

        // search if the prerequisites are present
        url = SIP_URL + "/checkprerequisites/" + nodeNumber + "/" + ccproductid;
        headerSection = { headers: { "Authorization": `Bearer ${getSessionItem(TOKEN_2)}` } };

        response = await fetchData(url, headerSection, prerequisitesHandler);

        if (prerequisites) {
            prerequisites.forEach(preReq => {
                if ((preReq.isExisting !== true) && (preReq.parameter === "ENTITY_1")) {
                    errmsg = getTranslated(dict, "LABEL_ENTITY_1");
                    errmsg += "<br/><small style='color: #5050F0;'>Entities&nbsp;>&nbsp;1</small>";
                    msg = parse(errmsg);
                    prereq_error = true;
                }
            });
        }
        else {
            console.log("Prerequisites error (1).")
        }
        if (prereq_error === true) {
            // Gtm event for SIP trunk creation failure
            sendGTMEvent({
                 event: "umc_SIP_trunk_creation_completed",
                 status: "Failure",
                 sip_profile: "NO_SIP_PROFILE",
                 cc_product_id: getSessionItem(CC_PRODUCT_ID) // Taken from session
            })

            // Display the error message
            setModalType("Error");
            setTitle(getTranslated(dict, "LABEL_PREREQUISITES_TITLE"));
            setMessage(msg);
            setFooter([close]);
            showModal();
        }
        else {
            // Display the backup message
            setModalType("Info");
            setTitle(getTranslated(dict, "LABEL_RECOMMENDATION"));
            setMessage(getHTMLObject(dict, "LABEL_BACKUP"));
            setFooter([cancel, ok]);
            showModal();
        }

    }

    return (
        <>
            <div>
                <UMCButton
                    label={getTranslated(dict, "LABEL_ADD_SIP_TRUNK_BTN")}
                    type="primary"
                    onClick={createNewSIPTrunk}
                    className="sip-btn-fontsize"
                />
                <div>
                    <br />
                    <UMCTable dataSource={items} columns={columns} size="small" handleRowHover={() => { }} className='table-striped-rows' pagination={{ className: "custom-pagn", defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30'] }} />
                </div>
            </div>
            <CustomDialog
                title={title}
                open={isModalOpen}
                width="400px"
                footer={footer}
                type={modalType}
                onCancel={handleCancel}
            >
                {message}
            </CustomDialog>
        </>);
}

export default TrunkList;
